import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

export const Leasing = () => {
  const i18n = useI18n();

  return (
    <section className="flex flex-col gap-6 justify-around items-center mx-auto mb-24 w-full max-w-[90rem] md:mb-14 lg:flex-row lg:px-3 lg:mb-0 xl:px-[120px] 2xl:px-[90px]">
      <div className="hidden max-w-[50%] lg:block">
        <Image
          src={"/images/environment/leasing.webp"}
          alt="Picture of an iPhone and a a card saying too smart to buy"
          width={1120}
          height={877}
        />
      </div>
      <div className="w-full lg:hidden">
        <Image
          src={"/images/environment/leasing-mobile.webp"}
          alt="Picture of an iPhone and a a card saying too smart to buy"
          className="object-cover"
          width={390}
          height={251}
        />
      </div>
      <article className="flex flex-col gap-3 px-[30px] md:gap-6 lg:py-16 lg:px-0 lg:w-1/2">
        <h3 className="text-[30px] font-black leading-8 text-center md:text-[42px] md:leading-[42px] lg:text-left 2xl:whitespace-nowrap">
          {i18n.t("environment.leasing.title", {}, { html: true })}
        </h3>
        <p className="[&_.footer]:text-[20px] [&_.footer]:lg:text-[24px] text-[16px] [&_.font-bold]:font-bold leading-[24px] [&_a]:text-cornflower-blue [&_.text-pastel-green-2]:text-pastel-green-2 [&_a]:underline lg:text-[18px] lg:leading-[30px]">
          {i18n.t("environment.leasing.text", {}, { html: true })}
        </p>
      </article>
    </section>
  );
};
